import { render, staticRenderFns, recyclableRender, components } from "./combPro.vue?vue&type=template&id=667c0cca&"
var renderjs
import script from "./combPro.vue?vue&type=script&lang=js&"
export * from "./combPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!C:\\Users\\dell\\Downloads\\HBuilderX.3.2.16.20211122.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/basics/combPro.vue"
export default component.exports